import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GlmD3BarChartComponent} from './glm-D3-bar-chart/glm-D3-bar-chart.component';
import {GlmD3LineChartComponent} from './glm-D3-line-chart/glm-D3-line-chart.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    GlmD3BarChartComponent,
    GlmD3LineChartComponent
  ],
  declarations: [
    GlmD3BarChartComponent,
    GlmD3LineChartComponent
  ],
  providers: [],
})
export class GlmD3Module {
}
